<template>
  <div class="listItem-wrapper" :class="{ 'check': check, 'checked': checked }" @click="handleClick">
    <div class="top">
      <div class="main-info" :class="{ 'noSecInfo': !secInfoShow }">
        <div class="top">
          <label v-if="type === 1" :title="item.name" @click.stop="workDetails">
            {{ item.name && item.name.length > 8 ? item.name.substr(0, 8) + '...' : item.name }}
            <img v-if="item.resumeSourceType === '3'" src="../../assets/img/icon/icon_xz_PC.png" alt="" />
          </label>
          <label v-if="type === 2" :title="item.username" @click.stop="workDetails">{{ item.username }}</label>
          <label v-if="type === 3" :title="formatName(item.name)" @click.stop="workDetails">{{ formatName(item.name)
            }}</label>
          <!-- <span v-if="navType !== 3"><slot name="mainInfo"></slot></span>
          <span v-if="type=== 1 && navType === 3" class="red">面试时间：{{ item.invitedTime | dateFormatFun(4) }}</span> -->
        </div>
        <div v-if="type === 1" class="bottom">
          <label v-if="item.limitSalary !== 0">{{ item.limitSalary + 'k' }}-{{ item.topSalary + 'k' }}</label>
          <label v-else>面议</label>
          <span>
            <i>{{ item.areaName | cityFmt }}</i>
            <i>{{ item.experienceStr }}</i>
            <i>{{ item.educationStr }}</i>
          </span>
        </div>
        <div v-if="type === 2" class="bottom">
          <label>{{ item.expectedSalary }}</label>
          <span>
            <i>{{ item.currentCity }}</i>
            <i>{{ item.workAllTimeStr }}</i>
            <i>{{ item.highestEducationStr }}</i>
          </span>
        </div>
        <div v-if="type === 3" class="bottom">
          <label>{{ item.applyrecord }}</label>
          <span>
            <i style="color:red;">{{ item.expectedSalaryStr }}</i>
            <i>{{ item.mailingAddress }}</i>
            <i v-if="showIt">{{ item.workAllTimeStr }}</i>
            <i v-if="showIt">{{ item.educationStr }}</i>
          </span>
        </div>
      </div>
      <div v-if="secInfoShow" class="sec-info">
        <img :src="ajaxUrl.readFile(item.photoUrl)" alt="公司封面">
        <div class="company">
          <label>{{ item.companyName }}</label>
          <span>{{ item.unitNatureStr }} {{ item.companyScaleStr }}</span>
        </div>
      </div>
      <div class="btn-info">
        <slot name="btnInfo"></slot>
      </div>
    </div>
    <div class="bottom">
      <ul v-if="type === 1 && item.welfareList" class="welfare">
        <li v-for="(item, index) in item.welfareList.slice(0, 5)" :key="index">{{ item }}</li>
      </ul>
      <ul v-if="type === 2" class="hope">
        <li v-if="navType === 1 || navType === 2 || navType === 3">应聘岗位：{{ item.postName }}</li>
        <li v-if="navType === 4">期望职能：{{ item.expectIndustry }}/{{ item.expectedPosition }}</li>
        <li>期望地点：{{ item.expectedAddress | cityFmt }}</li>
        <li v-if="navType === 1" class="last">投递时间：{{ item.createTime | dateFormatFun(4) }}</li>
        <li v-if="navType === 2 && showTime" class="last">面试时间：{{ item.invitedTime | dateFormatFun(4) }}</li>
        <li v-if="navType === 3" class="last">拒绝时间：{{ item.updateTime | dateFormatFun(4) }}</li>
      </ul>
      <ul v-if="type === 3" class="hope">
        <li v-if="navType === 1 || navType === 2 || navType === 3">应聘岗位：<span style="color:red;">{{ item.postName
            }}</span></li>
        <li v-if="navType === 1" class="last">投递时间：{{ item.createTime | dateFormatFun(4) }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
  import * as ajaxUrl from '../../ajax.config.js';
  import { formatName } from '@/util';

  export default {
    name: 'ListItem',
    data() {
      return {
        ajaxUrl: ajaxUrl,
        selectList: [] // 所勾选的项
      };
    },
    props: {
      item: {
        type: Object
      },
      // 类型，1 岗位信息 2 人才信息
      type: {
        type: Number,
        default: 1
      },
      // 投递记录类型，1 全部，2 邀面试 3 已拒绝 4 已收藏
      navType: {
        type: Number,
        default: -1
      },
      // 是否开启复选功能
      check: {
        type: Boolean,
        default: false
      },
      // 当前是否被选择
      checked: {
        type: Boolean,
        default: false
      },
      // 是否点击岗位名称跳转到招聘详情页
      workDetailsRouter: {
        type: Boolean,
        default: false
      },
      // 是否显示企业信息
      secInfoShow: {
        type: Boolean,
        default: true
      },
      showIt: {
        type: Boolean,
        default: true
      },
      showTime: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      formatName,
      handleClick() {
        this.$emit('click');
      },
      workDetails() {
        if (!this.workDetailsRouter) {
          this.$emit('click');
          return false;
        }
        const { href } = this.$router.resolve({ name: 'workDetails', query: { id: this.item.id } });
        window.open(href, '_blank');
      }
    }
  };
</script>

<style lang="sass" rel="stylesheet/sass" scoped>
  @import "ListItem.sass"
</style>
